import * as React from "react";
import { dialogService } from "react-api-dialog";
import { DialogClose } from "./DialogClose";

export function confirmDialog(body: JSX.Element | string, header?: JSX.Element | string, okText?: string, cancelText?: string) {
    const jsx = class extends React.Component<{ ok: (returnValue: any) => any, cancel: () => void }> {
        render() {
            return <div className="modal-content" style={{ width: 500, minHeight: 150, maxWidth: "calc(100% - 20px)" }}>
                <DialogClose onClose={this.props.cancel} />
                {!!header && <div className="modal-header">
                    {header}
                </div>}
                <div className="modal-body">
                    {body}
                </div>
                <div className="modal-footer">
                    <button className="btn btn-default" onClick={e => this.props.cancel()}>{cancelText || "Cancel"}</button>
                    <button className="btn btn-primary" onClick={e => this.props.ok(true)}>{okText || "Ok"}</button>
                </div>
            </div>
        }
    }
    return dialogService.showComponent(jsx, { hash: "confirm", animation: "modal", style: { height: "unset" } });
}
